module.exports = __webpack_public_path__ + "static/house_render_4-8bb2240825f9ffe2f15c33a76d188b69.jpg";